import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Submenu from './sub-menu';
import I18n from '../i18n';
export const TrackSelection = React.createContext();

export default function DropdownMenu(props) {
  const {onChange, className, options, value, disabled, name, ...rest} = props;
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [selected, setSelected] = React.useState(value || []);
  const thisDropdown = React.useRef();

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  React.useEffect(() => {
    setSelected(value);
  }, [value]);

  const contextValue = {
    selected,
    handleSelected,
  };

  const handleDropdownButtonClick = React.useCallback(() => {
    const nextState = !showDropdown;
    setShowDropdown(nextState);
  });

  const handleClickOutside = event => {
    if (!thisDropdown.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  function handleSelected(value) {
    setSelected(value);
    setShowDropdown(false);
    onChange(value);
  }

  function selectedMenus() {
    let opt = {submenu: options};
    return selected
      .map(sel => (opt = opt.submenu.find(opt => opt.id === sel)).menu)
      .map(sel => I18n.t(sel))
      .join(': ');
  }

  return (
    <div
      ref={thisDropdown}
      className={classnames(className, 'dropdown', showDropdown ? 'open' : '')}
      name={name}
      {...rest}
    >
      <button
        type="button"
        className={classnames('form-control', 'dropdown-button')}
        disabled={disabled}
        onClick={handleDropdownButtonClick}
      >
        {Boolean(selected.length) ? <label>{selectedMenus()}</label> : <label>{I18n.t('Select an Option')}</label>}
        <span className="fa fa-angle-down"></span>
      </button>
      {showDropdown && (
        <TrackSelection.Provider value={contextValue}>
          <Submenu options={options}></Submenu>
        </TrackSelection.Provider>
      )}
    </div>
  );
}

DropdownMenu.defaultProps = {};

DropdownMenu.propTypes = {
  /** A callback to execute when input changes. Will be passed the input value */
  onChange: PropTypes.func,
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** An array passed to the component for dropdown menu */
  options: PropTypes.array.isRequired,
  /** Value of the dropdown menu */
  value: PropTypes.array,
  /** Name of the dropdown menu */
  name: PropTypes.string,
  /** A boolean when passed disables the dropdown menu */
  disabled: PropTypes.bool,
};
